const differentials = [
  {
    icon: "ri-shield-check-line",
    title: "Empresa Séria",
    description: "Mais de 14 anos no mercado com reputação sólida e confiança garantida por milhares de clientes.",
    color: "bg-primary-50 text-primary-500",
  },
  {
    icon: "ri-truck-line",
    title: "Entrega Rápida",
    description: "Logística eficiente que garante seus materiais na obra no prazo certo, sem atrasos.",
    color: "bg-primary-50 text-primary-500",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Economia Garantida",
    description: "Preços competitivos, promoções frequentes e condições especiais para grandes pedidos.",
    color: "bg-primary-50 text-primary-500",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Melhor Atendimento",
    description: "Equipe especializada pronta para orientar e encontrar a melhor solução para sua obra.",
    color: "bg-primary-50 text-primary-500",
  },
  {
    icon: "ri-trophy-line",
    title: "Qualidade Premium",
    description: "Trabalhamos somente com as marcas mais renomadas e de maior confiabilidade do mercado.",
    color: "bg-accent-100 text-accent-600",
  },
  {
    icon: "ri-store-2-line",
    title: "2 Lojas Completas",
    description: "Duas unidades para atender você com mais comodidade, amplo estoque e variedade.",
    color: "bg-accent-100 text-accent-600",
  },
];

export default function Differentials() {
  return (
    <section className="w-full py-16 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-label font-semibold uppercase tracking-widest px-3 py-1 rounded-full mb-3">
            Por que nos escolher
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Nossos Diferenciais
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            A M&amp;Z é referência em materiais de construção porque vai além do produto — oferecemos a experiência completa.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {differentials.map((item, i) => (
            <div
              key={i}
              className="flex gap-4 p-6 bg-background-50 border border-background-200 rounded-lg hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 group animate-slide-up"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-lg shrink-0 ${item.color} group-hover:scale-110 transition-transform duration-300`}
              >
                <i className={`${item.icon} text-xl`} />
              </div>
              <div>
                <h3 className="font-heading font-semibold text-foreground-950 text-base mb-1">{item.title}</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}